import { NextHead } from "../src/landingPage/layouts/LayoutComponents/NextHead";
import { Careers } from "../src/landingPage/views/Careers/Careers";
import { meta } from "../src/landingPage/datasets/meta";

const CareersPage = () => {
  return (
    <>
      <NextHead
        currentPath="/careers"
        title={meta.careers.title}
        description={meta.careers.description}
      />
      <Careers />
    </>
  );
};

export const getInitialProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default CareersPage;
